import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Colors from "../styles/colors";
import AppIcon from "../images/ascend.svg";
import {LinearProgress} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    progress: {
        marginTop: 12,
        width: "100%",
    },
    colorPrimary: {
        backgroundColor: '#e5e8eb',
    },
    barColorPrimary: {
        backgroundColor: Colors.primary,
    },
}));

function WaitScreen()
{
    const style = useStyles()
    return(
      <div className={'wait-screen'}>
          <div className={'branding'}>
              <img src={AppIcon} alt={"AppIcon"}/>
              <LinearProgress
                  classes={{colorPrimary: style.colorPrimary, barColorPrimary: style.barColorPrimary}}
                  className={style.progress}/>
          </div>
      </div>
    );
}
export default WaitScreen;